import { NavLink } from "react-router-dom";
import './Header.css';
import logo from "/src/assets/img/png/logo-grey.png"
import { isPwa } from '/src/utils/isPwa';
import { useAuthStateContext } from "/src/features/auth/context/authContext";
import Storage from "/src/utils/storage";
function Header() {
    const {user} = useAuthStateContext();
    //const storage = Storage('local').get("user");
    const storage = Storage('session').get('company');
    var logo = storage?.logo;
    return (
        <div className="header">
            <NavLink to="/user/no-company"  target={user?.external_id || isPwa() ? "_self" : "_blank"}><img style={{ marginLeft : 2.5 }} src={logo ? logo : null} className="logo-talkr"/></NavLink>
            <span>Platform</span>
        </div>
    )
}

export default Header;
